import { addLaws9 } from '../content/laws9';
import {BLOCKS,PAYF,PAYG,RESP,RESP0} from '../content/blocks';
import {ISSUES} from '../content/issues';
import {ISS} from '../content/states';
import {clamp} from './util';




export function customFx(iss?:any,p?:any){
  const I=ISS[iss],imp=I.imp,resp=(k:any)=>(RESP[iss]||{})[k]??RESP0[k];
  let b=0,sev=0,cut=0,gr=0,vr=0,months=2,gg=false;const al=0;const g:any={},pos:any={};
  const add=(o:Record<string,number>,k:string,v:number)=>{o[k]=(o[k]||0)+v};
  for(const B of (p.blocks||[])){const v=+B.v||0;
    if(B.k==='fund'){b-=v;sev+=v*2.2*resp('fund');cut+=v*.025*resp('fund');for(const k in imp)add(g,k,v*.45*imp[k]);add(pos,'haushalt',v*.08);add(pos,'sozial',.25)}
    if(B.k==='pay'){const grp=PAYG[B.g||0];b-=v*PAYF[grp];add(g,grp,v*.12);sev+=v*.06*resp('pay')*(imp[grp]||.3);add(pos,'sozial',.4+v*.006);add(pos,'haushalt',v*.004)}
    if(B.k==='tax'){b+=v;sev+=v*1.5*resp('tax');const w=B.who||0;
      if(w===0){add(g,'unt',-v*.8);add(pos,'buero',-v*.04);gr-=v*.012}
      else if(w===1){for(const k of ['rent','fam','arb','jung'])add(g,k,-v*.3);add(pos,'steuern',-.2);add(pos,'sozial',-.3)}
      else{add(g,'unt',-v*.3);add(pos,'steuern',.5+v*.08);gr-=v*.006;vr+=v*.01}}
    if(B.k==='reg'){const st=(B.v||0)+1;sev+=st*5*resp('reg');cut+=st*.08*Math.max(0,resp('reg'));add(g,'unt',-st*1.5);add(pos,'buero',-st*.5);gr-=st*.02;vr+=[0,.1,.35][st-1]}
    if(B.k==='dereg'){const st=(B.v||0)+1;sev+=st*5*resp('dereg');add(g,'unt',st*2);gr+=st*.03;add(pos,'buero',st*.5);if(resp('dereg')<0)add(g,'jung',-st)}
    if(B.k==='staff'){const k=v/1000;b-=k*.08;sev+=k*1.2*resp('staff');cut+=k*.015*resp('staff');months+=1;for(const kk in imp)add(g,kk,k*.12*imp[kk]);add(pos,'haushalt',k*.02)}
    if(B.k==='pilot'){b-=v;sev+=v*1.5*resp('pilot');add(g,'jung',v*.5)}
    if(B.k==='gg'){gg=true;months+=1}
  }
  if(gg)cut*=1.3;
  for(const k in pos)pos[k]=clamp(pos[k],-2,2);
  return{months:Math.min(5,months),b:Math.round(b*10)/10,sev:Math.round(sev*10)/10,cut:clamp(cut,0,.9),g,gr:Math.round(gr*1000)/1000,al,pos,gg,vr:clamp(vr,0,.9),custom:true};
}
export function customLT(iss?:any,p?:any){const bl=p.blocks||[];let gr=0,pil=0;bl.forEach((B:any)=>{if(B.k==='fund')gr+=(+B.v||0)*.006;if(B.k==='pilot')pil+=(+B.v||0)});
  const r:any={delay:30,dur:18};if(gr)r.gr=gr;if(pil)r.sev={[iss]:-pil*5};return r}
ISSUES.forEach((i:any)=>i.laws.push({t:'Eigener Ansatz',r:i.law.r,br:1,custom:true,d:'Stellt euer eigenes Gesetz aus Bausteinen zusammen. Jeder Baustein wirkt je nach Problem unterschiedlich stark.',ps:[],fx:(p:any)=>customFx(i.id,p),lt:(p:any)=>customLT(i.id,p)}));
addLaws9(); // Version 9: neue Ansätze, nach dem eigenen Ansatz angehängt
export function newBlock(k?:any){const B=BLOCKS[k],o:Record<string,any>={k};B.ps.forEach((pa:any)=>o[pa.id]=pa.d);return o}
export function customDefault(iss?:any){return{title:`${ISS[iss].n}: eigenes Gesetz`,blocks:[newBlock(['bildung','sicher','aerzte','kita','pflege','wehr','cyber'].includes(iss)?'staff':'fund')]}}
